import { defineMessages } from 'react-intl';

const messages = defineMessages({
  SignUpPromptTitle: {
    defaultMessage: 'Sign up to favorite',
    description:
      'Title of the sign up modal when favoriting as a non-logged in user'
  },
  SignUpPromptDescription: {
    defaultMessage:
      'Join Redbubble to favorite, get daily recommendations, and save shipping and payment details for later.',
    description:
      'Description of the sign up modal when favoriting as a non-logged in user'
  },
  SignUpLink: {
    defaultMessage: 'Sign Up',
    description: 'Link to Sign up page when favoriting as a non-logged in user'
  },
  LogInLink: {
    defaultMessage: 'Log In',
    description: 'Link to Log in page when favoriting as a non-logged in user'
  }
});

export default messages;
